import script from "./RunnerStatsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RunnerStatsView.vue?vue&type=script&setup=true&lang=js"

import "./RunnerStatsView.vue?vue&type=style&index=0&id=f1341f86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1341f86"]])

export default __exports__